/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable import/extensions */
import * as React from 'react';
import 'antd/dist/reset.css';
import 'assets/styles/global.css';
import 'assets/styles/reset.css';
import { useEffect } from 'react';
import { Cookies, CookiesProvider } from 'react-cookie';
import ReactGA from 'react-ga';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter, useLocation, useNavigate, useRoutes } from 'react-router-dom';

import { ChakraProvider } from '@chakra-ui/react';
import { Web3Modal } from '@web3modal/react';
import { Modal } from 'antd';
import { R } from 'assets/value';
import { dispatch, reload, RXStore, useSelector, web3ModalConfig } from 'common';
import { ethereumClient, wagmiClient } from 'common/constant/wallet-connect';
import { useTracking } from 'common/hooks/useTracking';
import { ThemesProvider } from 'common/styled-themes';
import ErrorBoundary from 'containers/error-boundary/error-boundary';
import { ApiConstants, NetWorkService } from 'library/networking';
import I18n from 'library/utils/i18n/i18n';
import { WHITELIST_PERMISSION } from 'model/room.interface';
import { appActions } from 'redux/action-slice';
import { PersistGate } from 'redux-persist/integration/react';
import { blockAccessRoutes, fullAccessRoutes, routesMode } from 'routes';
import ROUTES from 'routes/constant';
import { persistor, store } from 'store/store';
import { useDisconnect, WagmiConfig } from 'wagmi';

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-YZQTLYGG82');

// import './index.scss';

const useAppMode = () => {
  const [isMaintenance, setIsMaintenance] = React.useState(false);
  const [isWhitelist, setIsWhitelist] = React.useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const { chatSelectedAccount } = useSelector(state => state.app);

  useEffect(() => {
    checkingMaintenanceStatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    console.log(chatSelectedAccount, 'chatSelectedAccount');
    if (chatSelectedAccount) {
      permissionCheckAccess(chatSelectedAccount);
    } else {
      setIsWhitelist(false);
    }
  }, [chatSelectedAccount]);

  const checkingMaintenanceStatus = async () => {
    const response = await NetWorkService.Get<boolean>({
      url: ApiConstants.GET_MAINTENANCE_STATUS,
    });

    setIsMaintenance(response?.data || false);

    if (response?.data && location.pathname !== ROUTES.maintenance) {
      navigate(ROUTES.maintenance);
    }
  };

  const permissionCheckAccess = async (account: string) => {
    //White list
    // const permissionResponse = await NetWorkService.Get<WHITELIST_PERMISSION>({
    //   url: ApiConstants.CHECK_WHITELIST,
    //   params: {
    //     address: account,
    //   },
    // });

    setIsWhitelist(true);

    // if (permissionResponse && permissionResponse.data) {
    //   const { is_exist } = permissionResponse.data;

    //   setIsWhitelist(is_exist);
    // } else {
    //   setIsWhitelist(false);
    // }
  };

  return {
    isMaintenance,
    isWhitelist,
  };
};

/**
 * Entry point for route component
 * @returns JSX Element represents for route components
 */

const Main = () => {
  //state
  const { isMaintenance, isWhitelist } = useAppMode();
  const getRoutes = (isMaintenance: boolean, isWhitelist: boolean) => {
    if (isMaintenance) {
      return routesMode;
    }
    if (!isWhitelist) {
      return blockAccessRoutes;
    }

    return fullAccessRoutes;
  };
  const element = useRoutes(getRoutes(isMaintenance, isWhitelist));
  const { disconnect } = useDisconnect();
  useTracking(process.env.REACT_APP_GA_MEASUREMENT_ID);
  const { sessionExpired } = useSelector(state => state.app);
  const cookie = new Cookies();
  //render
  return (
    <>
      {element}
      <Modal
        width={350}
        open={sessionExpired}
        centered
        closable={false}
        afterClose={() => {
          disconnect();
          cookie.remove(R.strings.TOKEN_INFORMATION);
          dispatch(appActions.reset());
        }}
        maskClosable={false}
        cancelButtonProps={{
          className: 'hide',
          style: { display: 'none' },
        }}
        okButtonProps={{
          style: {
            background: '#2a74eb',
          },
        }}
        onOk={() => {
          // window.location.replace(ROUTES.home);
          disconnect();
          cookie.remove(R.strings.TOKEN_INFORMATION);
          dispatch(appActions.reset());
        }}>
        <div className="container mx-auto text-center">
          <h6 className="text-sm font-sans font-semibold">
            Session has expired, please login again
          </h6>
        </div>
      </Modal>
    </>
  );
};

/**
 * Entry point for App
 * @returns JSX Element represents for app
 */
const App = () => {
  //effect
  useEffect(() => {
    dispatch(appActions.onLoadApp());
  }, []);

  //render
  return (
    <ChakraProvider>
      <ErrorBoundary onReset={reload}>
        <BrowserRouter>
          <CookiesProvider>
            <ThemesProvider>
              <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                  {/* <AntdConfigProvider> */}
                  <I18nextProvider i18n={I18n}>
                    <WagmiConfig client={wagmiClient}>
                      <Main />
                    </WagmiConfig>
                    <RXStore />
                    <Web3Modal {...(web3ModalConfig as any)} ethereumClient={ethereumClient} />
                  </I18nextProvider>
                  {/* </AntdConfigProvider> */}
                </PersistGate>
              </Provider>
            </ThemesProvider>
          </CookiesProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ChakraProvider>
  );
};

export default App;
